import { TextInput } from '@interstate/components/TextInput';
import { RateTypeToggleGroup, useSellRateField, useSellRateInputFocus } from '@makemydeal/dr-dash-components';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useSummaryFieldLinks } from '../../../../baseDealActivity/baseDealContainer/hooks/useSummaryFieldLinks';
import { useScenarioCellId } from '../../../hooks/useScenarioCellId';

import { RowLabelAction } from '../../RowLabelAction';
import { CompositeValue } from '../../CompositeValue';
import { ScenarioManualEditMarker } from '../../ScenarioManualEditMarker';
import { ScenarioRow } from '../../ScenarioRow';

export const RATE_LINK_LABEL = 'Rate';

export const RateRow = () => {
    const { openLenderFromRate } = useSummaryFieldLinks();
    const {
        label,
        isLeaseOffer,
        isAprRateType,
        isLocked,
        isPaymentGridEnabled,
        isUserProgramQuotes,
        onRateTypeToggle,
        overrideIndicatorProps,
        inputProps
    } = useSellRateField({ tabName: DealTabs.SUMMARY, onLenderSlideOutOpen: openLenderFromRate });
    const handleFocus = useSellRateInputFocus();
    const inputId = useScenarioCellId('rate');
    const showRateTypeToggle = isLeaseOffer && !isPaymentGridEnabled && isUserProgramQuotes;

    const { name, ...rateInputProps } = inputProps;
    const input = (
        <ScenarioManualEditMarker {...overrideIndicatorProps}>
            <TextInput
                {...rateInputProps}
                id={inputId}
                name={name}
                data-testid={name}
                label={label}
                displayLabel={false}
                size="sm"
                onFocus={handleFocus}
                readOnly={isPaymentGridEnabled}
            />
        </ScenarioManualEditMarker>
    );

    return (
        <ScenarioRow
            rowKey="rate"
            label={
                <RowLabelAction onActivate={openLenderFromRate} testId="rate-input-label">
                    {RATE_LINK_LABEL}
                </RowLabelAction>
            }
        >
            {showRateTypeToggle ? (
                <CompositeValue
                    control={
                        <RateTypeToggleGroup
                            inputField="sell-rate"
                            isAPRRateType={isAprRateType}
                            handleOnClick={onRateTypeToggle}
                            disabled={isLocked}
                            toggleWidth="100%"
                        />
                    }
                >
                    {input}
                </CompositeValue>
            ) : (
                input
            )}
        </ScenarioRow>
    );
};
